<template>
  <div class="main col-xs-12">
    <AppMessages
      v-bind:message="this.message"
      v-bind:show="this.show"
      v-bind:type="this.messageType" />

    <h1>View completed results</h1>
    <AppProductSearch ref="child"  />
    <form>

      <div class="form-group" v-show="product">
        <selectize v-model="batchId" :settings="batchSelectizeSettings" v-if="batches && batches.length > 0">
          <option :value="batchItem.id" v-bind:key="getUniqueKey('batchlist' + batchItem.batchNumber, index)" v-for="(batchItem, index) in batches">{{ batchItem.name }}</option>
        </selectize>
        <div v-else>
          <p v-show="!isLoading" style="color:red">Sorry, unable to find batch details for '{{ product }}'. Please make sure the CofA and ERP databases are synchronised correctly.</p>
        </div>
      </div>
    </form>

    <form v-if="results && results.length">
      <label class="label">PO No(s):</label>
      <br />
      {{ ponum }}

      <table v-if="results" class="table">
        <thead>
          <tr>
            <th class="table__header">Company</th>
            <th class="table__header">Product</th>
            <th class="table__header">No</th>
            <th class="table__header">Type</th>
            <th class="table__header">Description</th>
            <th class="table__header">Lower</th>
            <th class="table__header">Upper</th>
            <th class="table__header">Answer</th>
            <th class="table__header">Notes</th>
          </tr>
        </thead>
        <tbody>
          <tr v-bind:key="getUniqueKey('result' + result.product, index)" v-for="(result, index) in results">
            <td class="table__col">{{ result.company }}</td>
            <td class="table__col">{{ product.code }}</td>
            <td class="table__col">{{ result.parameterNo }}</td>
            <td class="table__col">{{ result.type }}</td>
            <td class="table__col">{{ result.description }}</td>
            <td class="table__col">{{ result.lowerLimit }}</td>
            <td class="table__col">{{ result.upperLimit }}</td>
            <td class="table__col">
              <template v-if="batchArchived">

                <div v-if="result.type !== 'CoO'">
                  {{ result.result }}
                </div>
                <multiselect disabled="disabled" v-if="result.type === 'CoO'"
                             v-model="selected"
                             :options="options"
                             :multiple="true"
                >
                </multiselect>
              </template>
              <template v-else>
                <div v-on:click="editTable(result)" v-if="result.type === 'CoO' && !result.edit">
                  <multiselect disabled=""  v-if="result.type === 'CoO'"
                               v-model="selected"
                               :options="options"
                               :multiple="true"
                  >
                  </multiselect>
                </div>

                <multiselect  v-if="result.type === 'CoO' && result.edit"
                             v-model="selected"
                             :options="options"
                             :multiple="true"
                >
                </multiselect>
                <a v-on:click="editTable(result)" v-if="!result.edit && result.type !== 'CoO'" class="table__link">{{ result.result }}</a>
                <input v-if="result.edit && result.type !== 'CoO'" class="input form-block" v-model="result.result" v-bind:class="{'form-group--error':result.error}" />
                <div>
                  <p style="margin-top:10px; font-weight: bold;" v-if="result.edit">Reason</p>
                  <textarea v-if="result.edit" class="input form-block" v-model="result.extInfo" maxlength="255" v-bind:class="{'form-group--error':result.error}"></textarea>
                </div>
                <div v-if="result.error" class="error">{{ result.error.msg }}</div>
                <button v-if="result.edit"
                        class="button button--alt button--sep"
                        type="button"
                        v-bind:disabled="result.originalResult == result.result && !result.type === 'CoO'"
                        v-on:click="updateAnswer(result)">
                  Update
                </button>
                <button v-show="(result.originalResult != result.result || result.error != null) && result.type !== 'CoO'" style="margin-left:10px;"
                        class="button button--alt button--sep"
                        type="button"
                        v-on:click="clearEdit(result)">
                  Undo
                </button>
              </template>
            </td>
            <td class="table__col">
              <div v-bind:key="getUniqueKey('result_audit' + result.product, index)" v-for="(audit, index) in result.audit">
                <p v-if="audit.date">
                  {{ audit.date | formatDate }}
                </p>
                <ul>
                  <li v-if="!audit.newResult" v-bind:key="getUniqueKey('auditdate' + product, index)">
                    Answer archived
                  </li>
                  <template v-else>
                    <li v-if="audit.newResult != audit.oldResult" v-bind:key="getUniqueKey('auditoldresult' + product, index)">
                      Answer changed from <span style="font-weight:bold">'{{ audit.oldResult }}'</span> to <span style="font-weight:bold">{{ audit.newResult }}</span>
                    </li>
                    <li v-if="audit.newExtraInfo != audit.oldExtraInfo" v-bind:key="getUniqueKey('auditdateextra' + product, index)">
                      Extra Info changed from <span style="font-weight:bold">'{{ audit.oldExtraInfo }}'</span> to <span style="font-weight:bold">{{ audit.newExtraInfo }}</span>
                    </li>
                  </template>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="form-group" v-if="results && !batchArchived">
        <button class="button button--alt button--clear" v-on:click="archiveBatch()" type="button">Archive</button>
        <p>
          <input id="copy-product" class="checkbox" type="checkbox" v-on:click="copyTest()" />
          <label for="copy-product" class="label label--alt-inline">Copy to another product</label>

          <template v-if="copy">
            <selectize v-model="productcopy" :settings="selectizeSettings">
              <option :value="product.code" v-bind:key="getUniqueKey('prodcopy', product.code)" v-for="product in products">{{ product.code }}</option>
            </selectize>

            <selectize v-bind:disabled="!productcopy" v-model="batchcopy" :settings="manualSelectizeSettings">
              <option value="_manual_" data-sort-value="">Manual</option>
              <option :value="copybatch.batchNumber" v-bind:data-sort-value="copybatch.batchNumber" v-bind:key="getUniqueKey('batchcopy_' + index + '_', copybatch.batchNumber)" v-for="(copybatch, index) in copybatches">{{ copybatch.batchNumber }}</option>
            </selectize>

            <input v-if="manualCopy" v-model="manualbatchcopy" class="input form-gap" />

            <button class="button button--alt" type="button" v-bind:disabled="(!productcopy || !batchcopy || (manualCopy && !manualbatchcopy))" @click="copyToAnotherProduct()">Copy</button>
            <div v-if="genericErrors.length > 0 ">
              <div>Please correct the following generic errors</div>
              <ul class="form-group--error">
                <li v-for="error in genericErrors" class="error">
                  {{ error }}
                </li>
              </ul>
            </div>
          </template>
        </p>
      </div>
    </form>

    <div v-if="results && results.length">
      <h2>Attached Files</h2>
      <table class="table table--half table--seperator" v-if="externalAttachments.length > 0">
        <thead>
          <tr>
            <th class="table__header" v-if="!batchArchived"></th>
            <th class="table__header">File</th>
            <th class="table__header">Ext</th>
            <th class="table__header">Created</th>
          </tr>
        </thead>
        <tbody>
          <tr v-bind:key="getUniqueKey('in', index)" v-for="(attachment, index) in externalAttachments">
            <td class="table__col" v-if="!batchArchived">
              <a class="table__link" v-on:click="deleteFile(attachment, false)">Delete</a>
            </td>
            <td class="table__col"><a :href="attachment.url">{{ attachment.fileName }}</a></td>
            <td class="table__col">{{ attachment.extension }}</td>
            <td class="table__col">{{ attachment.created | formatDate }}</td>
          </tr>
        </tbody>
      </table>
      <p v-else>
        None
      </p>

      <h2>Attached Files (not sent to customer)</h2>
      <table class="table table--half" v-if="internalAttachments.length > 0">
        <thead>
          <tr>
            <th class="table__header" v-if="!batchArchived"></th>
            <th class="table__header">File</th>
            <th class="table__header">Ext</th>
            <th class="table__header">Created</th>
          </tr>
        </thead>
        <tbody>
          <tr v-bind:key="getUniqueKey('ex', index)" v-for="(attachment, index) in internalAttachments">
            <td class="table__col" v-if="!batchArchived">
              <a class="table__link" v-on:click="deleteFile(attachment, true)">Delete</a>
            </td>
            <td class="table__col"><a :href="attachment.url">{{ attachment.fileName }}</a></td>
            <td class="table__col">{{ attachment.extension }}</td>
            <td class="table__col">{{ attachment.created | formatDate }}</td>
          </tr>
        </tbody>
      </table>
      <p v-else>
        None
      </p>
    </div>

  </div>
</template>

<script>
  import Selectize from 'vue2-selectize';
  import axios from 'axios';
  import Multiselect from 'vue-multiselect';
  import AppMessages from '@/components/AppMessages/AppMessages.vue';
  import AppProductSearch from '@/components/AppProductSearch/AppProductSearch.vue';
  import Validation from '../validation'
  import SelectPopulate from '../mixins/SelectPopulate';
  import SearchObjects from '../mixins/SearchObjects';

  export default {
    name: 'results',
    components: {
      Selectize,
      Multiselect,
      AppMessages,
      AppProductSearch
    },
    mixins: [SelectPopulate, SearchObjects],
    data() {
      return {
        selectizeSettings: {
          maxOptions: 10000,
          sortField: [{ field: 'value', direction: 'asc' }, { field: '$score' }],
          allowEmptyOption: false,
          placeholder: 'Select value'
        },
        batchSelectizeSettings: {
          maxOptions: 10000,
          sortField: [{ field: '$order' }, { field: 'value', direction: 'asc' }, { field: '$score' }],
          allowEmptyOption: false,
          placeholder: 'Select value'
        },
        manualSelectizeSettings: {
          maxOptions: 10000,
          sortField: [{ field: 'data-sort-value', direction: 'asc' }, { field: '$score' }],
          allowEmptyOption: false,
          placeholder: 'Select value'
        },
        products: [],
        product: null,
        productcopy: null,
        batchcopy: null,
        manualbatchcopy: null,
        batchId: null,
        batch: null,
        batches: null,
        results: null,
        itemx: '',
        cert: '',
        ponum: null,
        copy: false,
        message: '',
        messageType: '',
        internalAttachments: [],
        externalAttachments: [],
        manualCopy: false,
        copybatches: [],
        archivedResults: true,
        show: false,
        genericErrors: [],
        isLoading: false,
        selected: null,
        options: [],
        multiSelectDisabled: true
      };
    },
    created() {
      this.message = ''; // Reset any previous messages
      this.messageType = '';
      this.show = false;
      this.products = []; // Reset products array
      const url = '/all-products'; // Endpoint to fetch products

      if (this.$Progress) {
        this.$Progress.start(); // Start the loading progress bar
      }

      axios
        .get(url)
        .then((response) => {
          this.products = response.data; // Update the products with the API response
          this.$Progress.finish(); // Finish the loading progress
        })
        .catch((error) => {
          this.$Progress.fail(); // Fail the loading progress
          this.message = 'Error loading products'; // Set error message
          this.messageType = 'message message--error'; // Error message style
          this.show = true; // Show the error message
        });
    },
    mounted() {
        this.$watch(
          '$refs.child.selectedProduct',
        (newValue, oldValue) => (this.product = newValue)
        );
    },
    computed: {
      batchArchived() {
        if (!this.batchId) return false;

        const batchInfo = this.getBatchInfo();
        return batchInfo && batchInfo.type === 'archived';
      },
    },
    watch: {
      product(value) {
        if (!value) {
          this.batchId = null;
          this.cert = null;
          this.batches = [];
          this.resetForm();
          return;
        }


        this.cert = `${value.certType} | ${value.description}`;

        this.loadBatches();
      },
      batchId(value) {
        if (!value) {
          this.results = [];
          this.resetForm();
          return;
        }
        this.loadBatchResults();
      },
      batchcopy(value) {
        if (!value) {
          this.manualCopy = null;
          this.manualbatchcopy = null;
          return;
        }

        this.manualCopy = value === '_manual_';
      },
      productcopy(value) {
        this.message = '';
        this.messageType = '';
        this.show = false;

        this.copybatches = [];
        const url = `products/${value}/batches`;

        if (!value) {
          return;
        }

        this.$Progress.start();

        axios
          .get(url)
          .then((r) => {
            this.copybatches = r.data;
            this.$Progress.finish();
          })
          .catch((r) => {
            this.$Progress.fail();
            this.message = 'Batches to copy not loaded';
            this.messageType = 'message message--error';
            this.show = true;
          });
      },
    },
    methods: {
      resetForm() {
        this.results = [];
        this.internalAttachments = [];
        this.externalAttachments = [];
        this.productcopy = '';
        this.copy = false;
        this.manualbatchcopy = null;
        this.manualCopy = '';
        this.batchcopy = null;
      },
      deleteFile(attachment, isinternal) {
        this.message = '';
        this.messageType = '';
        this.show = false;
        // eslint-disable-next-line
        if (!confirm('Do you really want to delete?')) {
          return;
        }

        const method = isinternal ? 'private-file-delete' : 'file-delete';

        let batchNo = '';

        if (this.batchId != null) {
          batchNo = encodeURIComponent(this.batchId);
        }

        const url = `products/${this.product.code}/batches/${batchNo}/${method}`;

        const data = {
          fileName: attachment.fileName,
        };

        this.$Progress.start();

        axios
          .post(url, data)
          .then(() => {
            this.$Progress.finish();
            this.message = 'File deleted successfully';
            this.messageType = 'message message--success';
            this.show = true;
            this.loadBatchResults();
          })
          .catch((e) => {
            this.$Progress.fail();
            this.message = `File not deleted: ${e.response.data.join(', ')}`;
            this.messageType = 'message message--error';
            this.show = true;
          });
      },
      editTable(result) {
        // eslint-disable-next-line
        result.edit = !result.edit;
        if (result.type === 'CoO') {
          this.multiSelectDisabled = false;
        }
      },
      clearEdit(result) {
        result.edit = false;
        result.result = result.originalResult;
        result.error = null;
      },
      updateAnswer(item) {

        this.$Progress.start();
        this.message = '';
        this.messageType = '';
        this.show = false;

        let batchNo = '';

        if (this.batchId != null) {
          batchNo = encodeURIComponent(this.batchId);
        }

        const url = `/products/${this.product.code}/batch-results/${batchNo}/results/${item.parameterNo}`;

        this.results.forEach((r) => { r.error = null; });
        this.genericErrors = [];

        const $scope = this;

        if (item.type === 'CoO') {
          item.result = JSON.stringify(this.selected);
        }

        axios.post(url, {
          type: item.type,
          description: item.description,
          upperLimit: item.upperLimit,
          lowerLimit: item.lowerLimit,
          result: item.result,
          extInfo: item.extInfo,
          parameterNo: item.parameterNo,
        })
          .then(() => {
            this.message = 'Result updated successfully';
            this.messageType = 'message message--success';
            this.show = true;
            this.$Progress.finish();

            this.loadBatchResults();
          })
          .catch((e) => {

            if (e.response.data != undefined) {

              var batchErrors = [];

              Validation.parseServerErrors(e.response.data, batchErrors, $scope.genericErrors);
              Validation.updateErrorMessages(batchErrors, $scope.results, [], []);

              this.message = 'Something went wrong when saving. Please try again.';
              this.messageType = 'message message--error';
              this.show = true;
            }
          });

        this.$Progress.fail();
      },
      copyTest() {
        this.copy = !this.copy;
      },
      archiveBatch() {

        // eslint-disable-next-line
        if (!window.confirm('Are you sure you want to archive these results?')) {
          return;
        }

        this.$Progress.start();
        this.message = '';
        this.messageType = '';
        this.show = false;

        let batchNo = '';

        if (this.batchId != null) {
          batchNo = encodeURIComponent(this.batchId);
        }

        const url = `/products/${this.product.code}/batch-results/${batchNo}/archive`;
        axios
          .post(url)
          .then(() => {
            this.$Progress.finish();
            this.message = 'Batch archived successfully';
            this.messageType = 'message message--success';
            this.show = true;
            this.loadBatches();
            this.batchId = null;
          })
          .catch((e) => {
            this.message = `Batch not archived: ${e.response.data.join(', ')}`;
            this.messageType = 'message message--error';
            this.show = true;
            this.$Progress.fail();
          });
      },
      copyToAnotherProduct() {
        this.$Progress.start();
        this.message = '';
        this.messageType = '';
        this.show = false;

        this.results.forEach((r) => { r.error = null; });
        this.genericErrors = [];

        let destinationBatch = this.batchcopy;
        if (destinationBatch === '_manual_') {
          destinationBatch = this.manualbatchcopy;
        }

        let batchNo = '';

        if (this.batchId != null) {
          batchNo = encodeURIComponent(this.batchId);
        }

        const url = `/products/${this.product.code}/batch-results/${batchNo}/copy`;
        const $scope = this;

        axios.post(url, {
          srcProductCode: this.product,
          srcBatchNo: this.batchId,
          destProductCode: this.productcopy,
          destBatchNo: destinationBatch,
          batchResults: this.results,
        })
          .then(() => {
            this.$Progress.finish();
            this.message = 'Batch copied successfully';
            this.messageType = 'message message--success';
            this.show = true;
          })
          .catch((e) => {
            this.$Progress.fail();

            if (e.response.data != undefined) {

              var batchErrors = [];

              Validation.parseServerErrors(e.response.data, batchErrors, $scope.genericErrors);
              Validation.updateErrorMessages(batchErrors, $scope.results, [], []);

              this.message = 'Unable to save batch records. Please correct validation errors before continuing';
              this.messageType = 'message message--error';
              this.show = true;
            }
          });
      },
      loadBatchResults() {
        this.results = null;
        this.ponum = null;

        if (!this.batchId) return;

        this.$Progress.start();

        const batch = this.getBatchInfo();

        if (batch.batchNumber != null) {
          batch.batchNumber = encodeURIComponent(batch.batchNumber);
        }

        let batchNo = '';

        if (this.batchId != null) {
          batchNo = encodeURIComponent(this.batchId);
        }

        const url = this.batchArchived
          ? `/products/${this.product.code}/batch-results/${batch.batchNumber}/archived`
          : `/products/${this.product.code}/batch-results/${batchNo}`;

        axios
          .get(url)
          .then((response) => {
            response.data.results.forEach((item) => {
              item.edit = false;
              if (item.type === 'CoO' && item.result !== '') {
                this.selected = JSON.parse(item.result);
              }
            });

            this.results = response.data.results;


            if (this.results) {
              if (Array.isArray(this.results)) {
                this.results.forEach(r => { r.originalResult = r.result });
              } else {
                this.results.originalResult = this.response.result;
              }
            }
            this.ponum = response.data.poNumbers.join(', ');
            this.internalAttachments = response.data.internalAttachments;
            this.externalAttachments = response.data.externalAttachments;

            this.$Progress.finish();
          })
          .catch((r) => {
            this.message = `Unable to retrieve batch results for 'batch' ${this.batchId}. Please try again.`;
            this.messageType = 'message message--error';
            this.show = true;
            this.$Progress.fail();
          });
      },
      getUniqueKey(prefix, index) {
        return `${prefix}_${index}`;
      },
      getBatchInfo() {
        return this.batches.filter(x => x.id === this.batchId)[0];
      },
      loadBatches() {
        this.$Progress.start();

        this.batchId = null;
        this.isLoading = true;
        axios
          .get(`/products/${this.product.code}/batchnumbers/all`)
          .then((response) => {
            this.batches = response.data;
            this.$Progress.finish();
          })
          .catch((r) => {
            this.message = `Unable to load batches for product '${this.product.code}'. Please try again.`;
            this.messageType = 'message message--error';
            this.show = true;
            this.$Progress.fail();
          }).finally(() => {
            this.isLoading = false;
          });
      },
    },
  };
</script>
